<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex pa-1 md9 sm10 xs12>
        <v-stepper v-model="e1">
          <v-stepper-header v-show="false">
            <v-stepper-step :complete="e1 > 1" step="1" />
            <v-stepper-step :complete="e1 > 2" step="2" />
            <v-stepper-step step="3" />
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
                <names-attending
                    :value="namesAttending"
                    @input="(newNames) => {namesAttending = newNames}"
                />
                <v-layout row>
                  <v-spacer></v-spacer>
                  <div v-if="namesAttending.accepts_rejects=='accepts'">
                    <v-btn color="primary" @click="e1 = 2">
                      CONTINUE
                    </v-btn>
                  </div>
                  <div v-else-if="namesAttending.accepts_rejects=='rejects'">
                    <v-btn color="primary" @click="e1 = 3">
                      CONTINUE
                    </v-btn>
                  </div>
                </v-layout>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card style="pa-0 ma-0">
                <h4>Choose entrees for {{ number_of_people }} guests</h4>
                <v-layout justify-center>
                  <v-flex xs12 sm8 md12 xl9>
                    <v-card flat pa-0 ma-0>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <menu-option
                            :value="beef"
                            @input="(newValue) => {beef = newValue}"
                          />
                          <menu-option
                            :value="chicken"
                            @input="(newValue) => {chicken = newValue}"
                          />
                          <menu-option
                            :value="fish"
                            @input="(newValue) => {fish = newValue}"
                          />
                          <menu-option
                            :value="other"
                            @input="(newValue) => {other = newValue}"
                          />
                          <menu-option
                            :value="kids"
                            @input="(newValue) => {kids = newValue}"
                          />
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="e1 = 1">BACK</v-btn>
                  <v-btn color="primary" @click="e1 = 3">
                    CONTINUE
                  </v-btn>
                </v-layout>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card>
                <h2>Thank you for your RSVP!</h2>
                <br>
                <h5>Please make sure everything looks good below</h5>
                <br>
                <invite-response-summary
                  :namesAttending="namesAttending"
                  :beef="beef"
                  :chicken="chicken"
                  :fish="fish"
                  :other="other"
                  :kids="kids"
                />
                <v-layout row>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="e1 = 2">BACK</v-btn>
                  <v-btn @click="submit" color="accent">
                    SUBMIT
                  </v-btn>
                </v-layout>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import NamesAttending from '@/components/NamesAttending.vue';
import MenuOption from '@/components/MenuOption.vue';
import InviteResponseSummary from '@/components/InviteResponseSummary.vue';


export default {
  name: 'invite-response-form',
  components: {
    NamesAttending,
    MenuOption,
    InviteResponseSummary,
  },
  data() {
    return {
      e1: 0,
      info: 'My Message',
      errors: [],
      responses: [],
      namesAttending: {
        names: '',
        accepts_rejects: '',
        number_of_people: 1,
      },
      beef: {
        selected: null,
        count: 0,
        title: 'Tenderloin of Beef, Grass-Fed',
        description: 'Wild mushroom, potato "box", port wine demi glace',
      },
      chicken: {
        selected: null,
        count: 0,
        title: 'Herb-Infused Chicken Breast',
        description: 'Haricots vert, fingerling potatoes, pearl onions',
      },
      fish: {
        selected: null,
        count: 0,
        title: 'Miso-Glazed Black Cod',
        description: 'Forbidden rice, radish, sesame',
      },
      other: {
        selected: null,
        count: 0,
        title: 'Vegetarian/Gluten Free',
        description: 'Other Options are Available. We will reach out to you for custom choices if interested.',
      },
      kids: {
        selected: null,
        count: 0,
        title: 'Kids Meals',
        description: 'Kids meals are available as well. We will reach out to you for custom choices if interested.',
      },
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    submit() {
      this.createRow();
    },
    createRow() {
      const URL = 'https://sheetdb.io/api/v1/by10w5ntqqhmd';
      const data = [
        {
          names: this.namesAttending.names,
          accepts_rejects: this.namesAttending.accepts_rejects,
          number_of_people: this.namesAttending.number_of_people,
          beef_count: this.beef.count,
          chicken_count: this.chicken.count,
          fish_count: this.fish.count,
          other_count: this.other.count,
          kids_count: this.kids.count,
        },
      ];
      axios
        .post(URL, { data })
        .then(response => this.responses.push(response))
        .catch(error => this.errors.push(error));
      this.$router.push('/rsvp-submit');
    },

  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h2 {
  text-align: center;
  font: 3.5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
</style>
